import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { text } from "../text";
import { components } from "../components";

interface PrivacyPoliceType {
  id: number;
  title?: string;
  description?: string;
  points?: string[];
  bottom?: string;
}

const privacyPolicy: PrivacyPoliceType[] = [
  {
    id: 0,
    // title: "NestFin – Privacy Policy",
    description:
      "NestFin Technologies Pvt. Ltd. (“NestFin”) is committed to protecting your privacy. This policy explains how we handle your information when you use the NestFin app.",
  },
  {
    id: 1,
    title: "1. Information We Collect",
    points: [
      "- Personal details (name, mobile number, email, gender)",
      "- Location data (with your permission) to show nearby PGs",
      "- Device and usage information (IP, OS, analytics)",
      "- Limited payment information via secure payment partners",
    ],
    bottom:
      "We do not store sensitive payment data like UPI PIN or full card numbers.",
  },
  {
    id: 2,
    title: "2. How We Use Your Data",
    points: [
      "- Show PGs and rental options relevant to you",
      "- Manage bookings, payments, and tenant onboarding",
      "- Send service updates, reminders, and confirmations",
      "- Improve app performance and user experience",
    ],
    bottom: "We never sell your information.",
  },
  {
    id: 3,
    title: "3. Sharing of Information",
    points: [
      "- PG owners/managers for booking communication",
      "- Verified service providers (payment gateway, SMS/WhatsApp, cloud services)",
      "- Legal authorities if required",
    ],
    bottom: "We do not share your data for marketing.",
  },
  {
    id: 4,
    title: "4. Data Security",
    description:
      "We use encryption, secure servers, and industry-standard measures to protect your data.",
  },
  {
    id: 5,
    title: "5. Your Rights",
    description:
      "You may request access, update, or deletion of your data. You may also withdraw permissions such as location access.",
    points: ["Email: hello@nestfin.app"],
  },
  {
    id: 6,
    title: "6. Updates to This Policy",
    description:
      "We may update this policy periodically. Continued app use indicates acceptance of the updated version.",
  },
  {
    id: 7,
    title: "7. Contact Us",
    description:"NestFin Technologies Pvt. Ltd.",
    points: [
      "Email: hello@nestfin.app",
      "Website: https://nestfin.app",
    ],
  },
];

export const PrivacyPolicy: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
  }, [pathname]);

  const renderHeader = (): JSX.Element => {
    return <components.Header title="Privacy Policy" goBack={true} />;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className="container" style={{ paddingBottom: 0 }}>
        <div style={{ marginTop: "10%", marginBottom: 20 }}>
          {privacyPolicy.map((item) => (
            <div style={{ marginBottom: "10%" }} key={item.id}>
              <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
              {item.description && <text.T14>{item.description}</text.T14>}

              <div>
               {item.points?.map((point, index) => {
  const lower = point.toLowerCase();

  if (lower.startsWith("email")) {
    const parts = point.split("Email:");
    const email = parts[1]?.trim(); // safe optional chaining
    return (
      <text.T14 key={index}>
        Email: &nbsp;
        {email ? (
          <a href={`mailto:${email}`} style={{ color: "#007bff" }}>
            {email}
          </a>
        ) : (
          point
        )}
      </text.T14>
    );
  } else if (lower.startsWith("website:")) {
    const parts = point.split("Website:");
    const url = parts[1]?.trim(); // safe optional chaining
    return (
      <text.T14 key={index}>
        Website: &nbsp;
        {url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff" }}
          >
            {url}
          </a>
        ) : (
          point
        )}
      </text.T14>
    );
  } else {
    return <text.T14 key={index}>{point}</text.T14>;
  }
})}

              </div>

              {item.bottom && (
                <text.T14 style={{ marginTop: "10px" }}>{item.bottom}</text.T14>
              )}
            </div>
          ))}
        </div>
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};


// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// import { text } from "../text";
// import { components } from "../components";

// // const privacyPolicy = [
// //   {
// //     id: 1,
// //     title: '1. Introduction',
// //     content:
// //       'We value your privacy and are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and safeguard your information when you use our PG booking platform.',
// //   },
// //   {
// //     id: 2,
// //     title: '2. Information We Collect',
// //     content:
// //       'We may collect personal details including your name, contact number, email, gender, and location preferences when you use our services. We may also collect location data (with your permission) to show PGs near you.',
// //   },
// //   {
// //     id: 3,
// //     title: '3. How We Use Your Information',
// //     content:
// //       'We use your data to provide personalized PG recommendations, communicate booking-related information, improve user experience, and send important service-related updates. Your information is never sold to third parties.',
// //   },
// //   {
// //     id: 4,
// //     title: '4. Sharing of Information',
// //     content:
// //       'We may share your data with PG owners or partners solely for the purpose of booking or inquiry. We do not share your personal information for any marketing or unrelated third-party services.',
// //   },
// //   {
// //     id: 5,
// //     title: '5. Cookies and Tracking',
// //     content:
// //       'We use cookies to enhance your browsing experience and gather analytics to improve our platform. You may choose to disable cookies via your browser settings, though this may affect functionality.',
// //   },
// //   {
// //     id: 6,
// //     title: '6. Security',
// //     content:
// //       'We implement appropriate technical and organizational measures to protect your data from unauthorized access, alteration, disclosure, or destruction.',
// //   },
// //   {
// //     id: 7,
// //     title: '7. Your Rights',
// //     content:
// //       'You have the right to access, correct, or delete your personal information at any time. You may also request that we stop using your data for certain purposes.',
// //   },
// //   {
// //     id: 8,
// //     title: '8. Changes to This Policy',
// //     content:
// //       'We may update this Privacy Policy periodically. We encourage you to review this page from time to time for any changes.',
// //   },
// //   {
// //     id: 9,
// //     title: '9. Contact Us',
// //     content:
// //       'If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact us at support@yourpgplatform.com.',
// //   },
// // ];

// interface PrivacyPoliceType {
//    id: number,
//     title: string,
//     description?: string,
//     points?: string[],
//     bottom?: string
// }

// const privacyPolicy : PrivacyPoliceType[] = [
//   {
//     id: 1,
//     title: "1. Use of the Platform",
//     description: "NestFin provides a platform to search, compare, and book PG and rental accommodations. NestFin is not a property owner; all property details, availability, pricing, and rules are managed by the respective PG owners/operators.",
//   },
//   {
//     id: 2,
//     title: "2. User Responsibilities",
//     description: "You agree to: ",
//     points: [
//       "- Provide accurate information during registration and booking.",
//       "- Verify property details before booking or moving in.",
//       "- Communicate responsibly with PG owners/operators.",
//     ],
//     bottom:
//       "NestFin is not responsible for disputes or inaccuracies in property listings.",
//   },
//   {
//     id: 3,
//     title: "3. Bookings & Payments",
//     // description: '',
//     points: [
//       "- Bookings are confirmed only after approval by the PG owner/operator.",
//       "- Payment terms and rental policies vary by property.",
//       "- Sensitive payment details (UPI PIN, card numbers) are not stored by NestFin.",
//     ],
//   },
//   {
//     id: 4,
//     title: "4. Cancellation & Refund Policy",
//     // description: '',
//     points: [
//       "- If a tenant cancels within 24 hours of the booking date, the token amount is refunded after deducting NestFin platform fee, payment gateway charges, and taxes.",
//       "- If the PG Owner/Operator cancels or denies the room after confirming the booking, the full token amount will be refunded after deducting platform fee, payment gateway charges, and taxes.",
//       "- Refund processing time depends on banking and payment gateway partners.",
//     ],
//   },
//   {
//     id: 5,
//     title: "5. Limitation of Liability",
//     description: "NestFin is not liable for:",
//     points: [
//       "- Disputes between tenants and PG owners.",
//       "- Inaccurate or misleading property information.",
//       "- Losses or damages arising from rental agreements.",
//       "- Platform downtime or technical errors.",
//     ],
//     bottom:"The app is provided “as is” without warranties."
//   },
//   {
//     id: 6,
//     title: "6. Changes to Terms",
//     description:
//       "NestFin may update these Terms at any time. Continued use of the app indicates acceptance of the updated Terms.",
//   },
//   {
//     id: 7,
//     title: "7. Contact Us",
//     description:  "NestFin Technologies Pvt. Ltd.",
//     points: [
//       "Email: hello@nestfin.app",
//       "Website: https://nestfin.app",
//     ],
//   },
  
// ];

// export const PrivacyPolicy: React.FC = () => {
//   const location = useLocation();
//   const { pathname } = useLocation();

//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };

//     scrollToTop();
//   }, [pathname]);

//   const renderImageBackground = (): JSX.Element => {
//     return <components.Background version={1} />;
//   };

//   const renderHeader = (): JSX.Element => {
//     return <components.Header title="Privacy Policy" goBack={true} />;
//   };

//   const renderContent = (): JSX.Element => {
//     return (
//       <main className="container" style={{ paddingBottom: 0 }}>
//         <div style={{ marginTop: "10%", marginBottom: 20 }}>
//           {privacyPolicy.map((item) => {
//             return (
//               <div style={{ marginBottom: "10%" }} key={item.id}>
//                 <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
//                 <text.T14>{item?.description}</text.T14>
//                <div>
//                 {item?.points?.map((point, index)=>{
//                   const lower = point.toLowerCase();

//                   return (
//                     <text.T14 key={index}>
//                       {
//                         lower.includes("email") ? (<>
//                         Eamil : &nbsp;
//                         <a  href={`mailto:${point.split("Email:")[1].trim()}`} style={{ color: "#007bff" }}>
//                               {point.split("Email:")[1].trim()}
//                         </a>
//                         </>
                        
//                       ) : lower.includes("website:") ? (
//                         <>
//                         Website :  &nbsp;
//                         <a  
//                             href={point.split("Website:")[1].trim()}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{ color: "#007bff" }}
//                         >
//                              {point.split("Website:")[1].trim()}
//                         </a>
//                         </>
//                       ) : (
//                         point
//                       )
//                       }
                      
//                       </text.T14>
//                   )
//                 })}
//                </div>

//                 <text.T14 style={{marginTop:"10px"}}>{item?.bottom}</text.T14>

//               </div>
//             );
//           })}
//         </div>
//       </main>
//     );
//   };

//   return (
//     <>
//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };
